module.exports = __webpack_public_path__ + "static/media/Clark-main.bb96eba2.jpg";